import { combineReducers } from 'redux';

import { loginReducer } from '../login/store/reducer';
import { notificationReducer } from '../notifications/store/reducer';
import { registrationReducer } from '../registration/store/reducer';
import { resetPasswordReducer } from '../resetPassword/store/reducer';

export const authReducer = combineReducers({
    login: loginReducer,
    registration: registrationReducer,
    resetPassword: resetPasswordReducer,
    notification: notificationReducer
});
